import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { COOKIE, getCookie } from '../Services/Cookie';
import ClearCachePage from '../Views/ClearCachePage';
/*
 * These guards are a routing convenience, never a security control. Everything
 * they read is client-writable, so they only decide which screen to render --
 * every actual authorisation decision is made server-side from the access
 * token. Nothing may be gated on these alone.
 *
 * The access token is no longer readable here: it lives in memory in the API
 * client and is absent entirely on a fresh page load until the refresh call
 * completes. Gating on it would bounce every logged-in user to the login page
 * on reload, so presence of a session is inferred from the identity cookies
 * instead. If that inference is wrong, the first API call returns 401 and the
 * client ends the session properly.
 */
const getUserRole = () => {
	let user = {
		userId:getCookie(COOKIE.UserId),
		role:getCookie(COOKIE.Role),
	}
	return user;
};
// Component to protect admin routes
export const AdminRoute = ({ children }) => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId){
		if (userRole?.role === '0'){
			// Redirect to home page or any other page if the user is not an admin
			return <Navigate to="/student-dashboard" state={{ from: location }} replace />;
		}
	}else{
		return <Navigate to="/staff-login" state={{ from: location }} replace />;
	}
	return children;
};
// Component to protect routes for students (e.g., prevent access to admin routes)
export const StudentRoute = ({ children }) => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId){
		if (userRole?.role !== '0'){
			// Redirect to a staff dashboard page or show an error message if a student is trying to access admin routes
			return <Navigate to="/dashboard" state={{ from: location }} replace />;
		}
	}else{
		return <Navigate to="/student-login" state={{ from: location }} replace />;
	}
	return children;
};
// Component to protect routes for types of admin users based on role
export const RoleProtectedRoute = ({allowedRoles, children }) => {
	const userRole = getUserRole();
	if (allowedRoles.includes(userRole?.role)){
		return children ? children : <Outlet/>;
	} else {
		return <Navigate to="/page-not-found" state={{ fromLocation:"fromRoutes" }} />;
	}
};

export default function lazyWithRetry(importFunction) {
  return React.lazy(() =>
    importFunction().catch(error => {
      if (error?.name?.includes('ChunkLoadError')) {
        return {
          default: ClearCachePage,
        };
      }
      throw error;
    })
  );
}
